<div class="min-h-[80vh] w-full pb-5">
<div class="hidden md:block">
  <ng-container *ngTemplateOutlet="hero; context: { isMobile: false }"></ng-container>
</div>

<div class="container block md:hidden">
  <ng-container *ngTemplateOutlet="hero; context: { isMobile: true }"></ng-container>
</div>

<ng-template #hero let-isMobile="isMobile">
  <div
    id="mask-image"
    class="w-full bg-[#001847] relative"
    [ngStyle]="{
      'height': isMobile ? '118px' : '309px',
      'border-radius': isMobile ? '16px' : null,
      'background-image': 'url(' + imageUrl + ')',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
      'background-size': 'cover'
    }"
  >
    <div class="container d-flex flex-col justify-center items-center">
      <div
        class="w-full text-center flex flex-col justify-center items-center float-end"
        [ngStyle]="{
          'height': isMobile ? '118px' : '309px'
        }"
      >
        <h1
          class="text-[#FAFAFA] title-img"
          [ngStyle]="{
            'font-size': isMobile ? '16px' : '40px',
            marginBottom: isMobile ? '8px' : '28px'
          }"
        >
          {{ data?.DealName }}
        </h1>

        <h2
          class="text-[#FAFAFA]"
          [ngStyle]="{
            'font-size': isMobile ? '13px' : '23px',
            'font-weight': isMobile ? '500' : '400'
          }"
        >
          {{ data?.DestinationDescription }}
        </h2>
      </div>
    </div>
  </div>
</ng-template>

  <div class="md:container px-[12px]">
    <div class="mt-10 hidden md:flex">
      <iho-breadcrumb class="" [items]="breadcrumbData"></iho-breadcrumb>
    </div>
      <div class="w-full city-select float-start">
        <h4 class="my-3 title-city">شهر های منتخب</h4>
        <iho-popular-destination [data]="data?.Destinations" />
      </div>
      <div>
        <ng-container *ngFor="let item of data?.DestinationsWithHotels; let i = index">
          <div class="w-full mb-[44px] md:mb-[54px]"   
            [attr.id]="'city-' + i" *ngIf="item.Hotels.length > 0">
            <div  class="w-full mt-10 flex mb-2 justify-between items-center">
              <div class="flex justify-center gap-1 items-center" >
                <h4 class=" my-3 title-city text-[16px] md:text-[19px]">{{item.CardHeaderPartial.Title}}</h4>
                <p *ngIf="item.CardHeaderPartial.Discount && item.CardHeaderPartial.Discount > 0" class="discount-label__segment px-3  border-2 user-select-none text-[#FF4242]">
                  <span class="d-inline fw-light title-discount"> تا </span>
                  <span  class="discount--number d-inline fw-bold title-discount">{{item.CardHeaderPartial.Discount | number:'1.0-0'}} درصد</span>
                  <span class="d-inline fw-light title-discount"> تخفیف </span>
                  <i class="text-l text-[#FF4242] iho-icon-discount-tag-01 mr-1"></i>
                </p>
              </div>
              <a
              [href]="item.CardHeaderPartial.Link.Url"
              class="text-blue-500 flex items-center gap-1 ml-[20px] title-all"
            >
              مشاهده همه
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </a>
              </div>
            
            <swiper [ngStyle]="{'paddingBottom' : '4px' , paddingRight : '4px'}" [config]="config" id="swiperDeals" *ngIf="resetSwiper()">
              <ng-template swiperSlide *ngFor="let cardData of item.Hotels">
                <a 
                  [href]="cardData?.Url"
                  target="_blank"
                  class="block"
                >
                  <iho-card 
                    [title]="cardData?.HotelName" 
                    [location]="cardData?.Address" 
                    [rating]="cardData?.Score.ScoreNumber" 
                    [reviewCount]="cardData?.Score.Total"
                    [BoardPrice]="cardData.Price.BoardPrice === cardData.Price.IhoPrice || ((((cardData.Price.BoardPrice - cardData.Price.IhoPrice) / cardData.Price.BoardPrice) * 100) < 5) ? 0 : (cardData.Price.BoardPrice | toToman)"
                    [price]="$any(cardData?.Price.IhoPrice | toToman )"
                    [type]="'hotel'"
                    [nights]="cardData?.Price.Nights + ' شب'"
                    [withPrice]="cardData?.Price.IhoPrice > 0 ? true : false"
                    [star]="cardData?.Star?.GradeId"
                    [discount]="cardData?.Discount?.Discount"
                    [image]="cardData?.PictureUrl">                
                      <span count-shab class="text-small font-medium text-gray-ds-300"> / شب</span>
                  </iho-card>
                </a>
              </ng-template>
            </swiper>
          </div>

        </ng-container>
      </div>
    </div>
    <div class="w-full h-px bg-gray-200 md:hidden mb-5"></div>
    <div class="flex container md:hidden">
      <iho-breadcrumb class="" [items]="breadcrumbData"></iho-breadcrumb>
    </div>

</div>